import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/sections/Header";
import BrandStrip from "@/components/sections/BrandStrip";
import Hero from "@/components/sections/Hero";
import About from "@/components/sections/About";
import Services from "@/components/sections/Services";
import WhyUs from "@/components/sections/WhyUs";
import Industries from "@/components/sections/Industries";
import Booking from "@/components/sections/Booking";
import Footer from "@/components/sections/Footer";
import ServicesIndexPage from "@/pages/ServicesIndexPage";
import WilmingtonServicePage from "@/pages/WilmingtonServicePage";
import WrightsvilleBeachServicePage from "@/pages/WrightsvilleBeachServicePage";
import CarolinaBeachServicePage from "@/pages/CarolinaBeachServicePage";
import SurfCityServicePage from "@/pages/SurfCityServicePage";
import ProfessionalRestroomCleaningPage from "@/pages/ProfessionalRestroomCleaningPage";
import PricingPage from "@/pages/PricingPage";
import BlogIndexPage from "@/pages/BlogIndexPage";
import BlogPostPage from "@/pages/BlogPostPage";

const Home = () => {
  const scrollToBook = () => {
    const el = document.getElementById("book");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <main data-testid="home-page" className="bg-white">
      <Header />
      <Hero onBook={scrollToBook} />
      <BrandStrip />
      <About />
      <Services onBook={scrollToBook} />
      <WhyUs />
      <Industries />
      <Booking />
      <Footer />
    </main>
  );
};

// Handles /#anchor hash navigation across pages (e.g., /services -> /#book)
const HashScroller = () => {
  const { hash, pathname } = useLocation();
  React.useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      // Wait for paint, then scroll
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 80);
    } else {
      window.scrollTo({ top: 0, behavior: "instant" });
    }
  }, [hash, pathname]);
  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <HashScroller />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<ServicesIndexPage />} />
          <Route path="/services/wilmington" element={<WilmingtonServicePage />} />
          <Route path="/services/wrightsville-beach" element={<WrightsvilleBeachServicePage />} />
          <Route path="/services/carolina-beach" element={<CarolinaBeachServicePage />} />
          <Route path="/services/surf-city" element={<SurfCityServicePage />} />
          <Route path="/services/professional-restroom-cleaning" element={<ProfessionalRestroomCleaningPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/blog" element={<BlogIndexPage />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
